// Version 1: sourced from docs/research/inspiration-2026-09-15/dimensions.json.
export const INSPIRATION_DIMENSIONS = [
  {
    key: 'source.identity_status',
    label: 'Identity status',
    family: '1. Source integrity and eligibility',
    description: 'matched, redirected-to-different-post, unavailable, login-blocked, not-checked',
    evidence: 'ID',
  },
  {
    key: 'source.preview_match',
    label: 'Preview match',
    family: '1. Source integrity and eligibility',
    description: 'matches-original, different-post, inconclusive',
    evidence: 'ID + F/V',
  },
  {
    key: 'source.preview_quality',
    label: 'Preview quality',
    family: '1. Source integrity and eligibility',
    description: 'usable, black-frame, obscured, platform-chrome, low-resolution, poor-crop',
    evidence: 'F',
  },
  {
    key: 'source.evidence_coverage',
    label: 'Evidence coverage',
    family: '1. Source integrity and eligibility',
    description:
      'metadata, notes, preview-only, sampled-video, full-video, audio, caption, carousel-complete',
    evidence: 'Evidence inventory',
  },
  {
    key: 'source.relevance',
    label: 'Relevance',
    family: '1. Source integrity and eligibility',
    description:
      'guest-stay, host-operations, investor-education, property-sale, news, entertainment, unrelated',
    evidence: 'M + C/V',
  },
  {
    key: 'source.media_origin',
    label: 'Media origin',
    family: '1. Source integrity and eligibility',
    description: 'real-footage-reported, synthetic-disclosed, virtual-game, mixed, unknown',
    evidence: 'M + V',
  },
  {
    key: 'source.stay_evidence',
    label: 'Stay evidence',
    family: '1. Source integrity and eligibility',
    description:
      'explicit-rental-link, creator-stay-report, operator-listing, accommodation-claim-only, none-established',
    evidence: 'M/C',
  },
  {
    key: 'source.review_status',
    label: 'Review status',
    family: '1. Source integrity and eligibility',
    description: 'pending, verified, needs-review, rejected, stale',
    evidence: 'ID + reviewer',
  },
  {
    key: 'identity.platform',
    label: 'Platform',
    family: '2. Platform, creator, and repetition',
    description: 'Instagram, Facebook, YouTube, TikTok',
    evidence: 'M',
  },
  {
    key: 'identity.format',
    label: 'Format',
    family: '2. Platform, creator, and repetition',
    description: 'image, carousel, reel/short, long-video, live-excerpt; verify native type',
    evidence: 'M/V',
  },
  {
    key: 'identity.language',
    label: 'Language',
    family: '2. Platform, creator, and repetition',
    description: 'spoken, overlay, and caption languages separately; multilingual supported',
    evidence: 'A/C',
  },
  {
    key: 'identity.creator_role',
    label: 'Creator role',
    family: '2. Platform, creator, and repetition',
    description:
      'guest, host, travel-creator, destination-account, architect/builder, publisher, aggregator',
    evidence: 'M/C',
  },
  {
    key: 'identity.creator_id',
    label: 'Creator id',
    family: '2. Platform, creator, and repetition',
    description: 'Stable platform identity; optional verified cross-platform entity',
    evidence: 'ID',
  },
  {
    key: 'identity.property_entities',
    label: 'Property entities',
    family: '2. Platform, creator, and repetition',
    description: 'One or more verified/attributed properties; unresolved allowed',
    evidence: 'M/N + review',
  },
  {
    key: 'identity.creative_family',
    label: 'Creative family',
    family: '2. Platform, creator, and repetition',
    description:
      'Original, exact repost, adapted repost, distinct production, unresolved; linked family ID',
    evidence: 'V/F + review',
  },
  {
    key: 'identity.commercial_relationship',
    label: 'Commercial relationship',
    family: '2. Platform, creator, and repetition',
    description:
      'paid-partnership, hosted-stay, affiliate/discount, owner-promotion, explicitly-independent, unknown',
    evidence: 'M/C/N',
  },
  {
    key: 'property.accommodation_type',
    label: 'Accommodation type',
    family: '3. Accommodation and setting',
    description:
      'cabin, cottage, apartment, villa, mansion, treehouse, houseboat, tent, dome, yurt, bus, castle, compound, other',
    evidence: 'M/F/N',
  },
  {
    key: 'property.architecture',
    label: 'Architecture',
    family: '3. Accommodation and setting',
    description:
      'A-frame, log, container, sculptural, earth-sheltered, glass, historic, modern, rustic, themed, other',
    evidence: 'F/M',
  },
  {
    key: 'property.setting',
    label: 'Setting',
    family: '3. Accommodation and setting',
    description: 'forest, mountain, desert, urban, farm, island, suburban, coast, lake, river',
    evidence: 'M/F',
  },
  {
    key: 'property.water_relationship',
    label: 'Water relationship',
    family: '3. Accommodation and setting',
    description: 'waterfront, water-view, water-access, over-water, boat-stay; distinguish each',
    evidence: 'M/F',
  },
  {
    key: 'property.geography',
    label: 'Geography',
    family: '3. Accommodation and setting',
    description:
      'country, administrative area, town, market; separate named place from market assignment',
    evidence: 'M/N',
  },
  {
    key: 'property.location_precision',
    label: 'Location precision',
    family: '3. Accommodation and setting',
    description: 'exact-property, municipality, metro/area, region, multiple-locations, unverified',
    evidence: 'M/N',
  },
  {
    key: 'property.capacity',
    label: 'Capacity',
    family: '3. Accommodation and setting',
    description: 'Stated maximum guests, bedrooms, beds, bathrooms as separate nullable numbers',
    evidence: 'M/N',
  },
  {
    key: 'property.privacy',
    label: 'Privacy',
    family: '3. Accommodation and setting',
    description:
      'entire-place, private-room, shared-stay, compound, resort-unit; amenity access separately',
    evidence: 'M',
  },
  {
    key: 'property.amenities',
    label: 'Amenities',
    family: '3. Accommodation and setting',
    description:
      'hot-tub, pool, sauna, theater, arcade, fireplace, firepit, kitchen, dock, workspace, telescope, slide, outdoor-shower, etc.',
    evidence: 'M/F/N',
  },
  {
    key: 'property.distinctive_mechanism',
    label: 'Distinctive mechanism',
    family: '3. Accommodation and setting',
    description:
      'roll-out-bed, secret-door, glass-floor, slide-entry, suspended-room, convertible-space, floating-room, etc.',
    evidence: 'M/F/V',
  },
  {
    key: 'guest.party_context',
    label: 'Party context',
    family: '4. Guest situation and desired experience',
    description:
      'couple, family, friends, reunion, solo, work-group; explicit context, not inferred relationships',
    evidence: 'C/N',
  },
  {
    key: 'guest.trip_occasion',
    label: 'Trip occasion',
    family: '4. Guest situation and desired experience',
    description:
      'birthday, anniversary, honeymoon, bachelorette, reunion, weekend-break, work-trip, home-transition, holiday',
    evidence: 'C/N',
  },
  {
    key: 'guest.activity',
    label: 'Activity',
    family: '4. Guest situation and desired experience',
    description:
      'stargazing, reading, coffee, cooking, swimming, games, hiking, kayaking, animal-encounter, remote-work, resting',
    evidence: 'V/F/C/N',
  },
  {
    key: 'guest.desired_benefit',
    label: 'Desired benefit',
    family: '4. Guest situation and desired experience',
    description:
      'reconnection, escape, novelty, comfort, play, privacy, convenience, discovery, shared-time',
    evidence: 'C/N + interpretation',
  },
  {
    key: 'guest.friction_addressed',
    label: 'Friction addressed',
    family: '4. Guest situation and desired experience',
    description:
      'travel-time, cost, space, weather, child-entertainment, access, uncertainty, coordination',
    evidence: 'C/N',
  },
  {
    key: 'guest.trip_stage',
    label: 'Trip stage',
    family: '4. Guest situation and desired experience',
    description:
      'discovery, imagining-stay, comparing, planning, booking, arrival, in-stay, remembering',
    evidence: 'C/V + interpretation',
  },
  {
    key: 'guest.time_commitment',
    label: 'Time commitment',
    family: '4. Guest situation and desired experience',
    description: 'day-trip, overnight, weekend, week, extended-stay; only when stated',
    evidence: 'M/C/N',
  },
  {
    key: 'guest.season_occasion',
    label: 'Season occasion',
    family: '4. Guest situation and desired experience',
    description: 'named season, holiday, event, school-break; separate visible weather',
    evidence: 'C/M/N',
  },
  {
    key: 'concept.primary',
    label: 'Primary',
    family: '5. Concept, promise, and proof',
    description:
      'unusual-stay-discovery, experience-demonstration, design-appreciation, value, togetherness, local-access, practical-confidence, nostalgia, humor',
    evidence: 'C/V/N',
  },
  {
    key: 'concept.secondary',
    label: 'Secondary',
    family: '5. Concept, promise, and proof',
    description: 'Additional supported reasons; max three to preserve focus',
    evidence: 'C/V/N',
  },
  {
    key: 'concept.promise',
    label: 'Promise',
    family: '5. Concept, promise, and proof',
    description: 'Short original abstraction of the promised benefit; no copied claim',
    evidence: 'C/V',
  },
  {
    key: 'concept.feature_benefit_links',
    label: 'Feature benefit links',
    family: '5. Concept, promise, and proof',
    description: 'Feature \u2192 activity \u2192 benefit, each with evidence and attribution',
    evidence: 'F/V/C/N',
  },
  {
    key: 'concept.proof_device',
    label: 'Proof device',
    family: '5. Concept, promise, and proof',
    description:
      'feature-in-use, spatial-demo, receipt, guest-account, review, map/distance, comparison, before-after',
    evidence: 'V/F/C',
  },
  {
    key: 'concept.objection_resolution',
    label: 'Objection resolution',
    family: '5. Concept, promise, and proof',
    description: "Named hesitation + source's response; unknown if not present",
    evidence: 'C/A/V',
  },
  {
    key: 'concept.price_framing',
    label: 'Price framing',
    family: '5. Concept, promise, and proof',
    description:
      'per-night, per-person, whole-stay, split-cost, comparison, property-purchase, unspecified',
    evidence: 'M/C',
  },
  {
    key: 'concept.claim_dependence',
    label: 'Claim dependence',
    family: '5. Concept, promise, and proof',
    description:
      'Requires actual price, capacity, availability, amenity, testimony, comparison, none',
    evidence: 'D from claims',
  },
  {
    key: 'narrative.structure',
    label: 'Structure',
    family: '6. Narrative and content structure',
    description:
      'spatial-tour, feature-reveal, experience-montage, day-in-life, arrival-story, list, comparison, transformation, testimonial, skit, explainer',
    evidence: 'V or complete carousel',
  },
  {
    key: 'narrative.perspective',
    label: 'Perspective',
    family: '6. Narrative and content structure',
    description: 'first-person-guest, second-person-invitation, host, observer, reviewer',
    evidence: 'A/C/V',
  },
  {
    key: 'narrative.scope',
    label: 'Scope',
    family: '6. Narrative and content structure',
    description:
      'one-detail, one-space, whole-property, full-stay, multiple-properties, destination',
    evidence: 'V/C/N',
  },
  {
    key: 'narrative.beat_sequence',
    label: 'Beat sequence',
    family: '6. Narrative and content structure',
    description:
      'Ordered abstract beats: setup, tease, reveal, demonstration, evidence, payoff, action',
    evidence: 'V',
  },
  {
    key: 'narrative.reveal_position',
    label: 'Reveal position',
    family: '6. Narrative and content structure',
    description: 'First reveal time and normalized fraction; immediate vs delayed derived',
    evidence: 'V',
  },
  {
    key: 'narrative.payoff',
    label: 'Payoff',
    family: '6. Narrative and content structure',
    description:
      'Discovery, emotional moment, demonstrated use, answer, punchline, recap, none-observed',
    evidence: 'V/A',
  },
  {
    key: 'narrative.information_density',
    label: 'Information density',
    family: '6. Narrative and content structure',
    description: 'Distinct factual/benefit points per duration; definition fixed in analyzer',
    evidence: 'V/C + D',
  },
  {
    key: 'narrative.series_context',
    label: 'Series context',
    family: '6. Narrative and content structure',
    description: 'standalone, numbered-part, recurring-series, continuation, unknown',
    evidence: 'M/C',
  },
  {
    key: 'narrative.loop',
    label: 'Loop',
    family: '6. Narrative and content structure',
    description: 'continuous-loop, verbal-loop, visual-return, no-loop-observed, unknown',
    evidence: 'V including ending',
  },
  {
    key: 'hook.semantic_device',
    label: 'Semantic device',
    family: '7. Opening and attention devices',
    description:
      'curiosity-gap, question, POV, unusual-feature, price, number/list, contrast, challenge, surprise, direct-benefit, story',
    evidence: 'Opening C/A/V',
  },
  {
    key: 'hook.visual_device',
    label: 'Visual device',
    family: '7. Opening and attention devices',
    description:
      'doorway-reveal, impossible-looking-structure, scenic-view, person-reaction, motion, close-detail, juxtaposition, action-in-progress',
    evidence: 'Opening V/F with known position',
  },
  {
    key: 'hook.channel',
    label: 'Channel',
    family: '7. Opening and attention devices',
    description: 'visual-only, overlay, speech, caption, coordinated-combination',
    evidence: 'Opening V/A/C',
  },
  {
    key: 'hook.first_subject',
    label: 'First subject',
    family: '7. Opening and attention devices',
    description: 'What is shown first: person, exterior, amenity, activity, landscape, title-card',
    evidence: 'V or verified opening F',
  },
  {
    key: 'hook.start_delay_ms',
    label: 'Start delay ms',
    family: '7. Opening and attention devices',
    description: 'Delay before meaningful subject/action begins',
    evidence: 'V',
  },
  {
    key: 'hook.promise_time_ms',
    label: 'Promise time ms',
    family: '7. Opening and attention devices',
    description: 'Time until the relevant premise is understandable',
    evidence: 'V/A/C + reviewer',
  },
  {
    key: 'hook.specificity',
    label: 'Specificity',
    family: '7. Opening and attention devices',
    description: 'Named feature/place/guest situation/benefit vs generic superlative',
    evidence: 'C/A',
  },
  {
    key: 'hook.curiosity_resolution',
    label: 'Curiosity resolution',
    family: '7. Opening and attention devices',
    description: 'Opening question/promise is answered, partly answered, not answered, unknown',
    evidence: 'Full V/C',
  },
  {
    key: 'hook.visual_word_alignment',
    label: 'Visual word alignment',
    family: '7. Opening and attention devices',
    description: 'reinforce, complementary, contradiction, unrelated, not-applicable',
    evidence: 'V/A/C',
  },
  {
    key: 'visual.primary_subject',
    label: 'Primary subject',
    family: '8. Visual composition and treatment',
    description: 'Property feature, person, action, architecture, landscape, object; with evidence',
    evidence: 'F/V',
  },
  {
    key: 'visual.subject_prominence',
    label: 'Subject prominence',
    family: '8. Visual composition and treatment',
    description: "Main subject's approximate screen share and occlusion",
    evidence: 'F/V',
  },
  {
    key: 'visual.shot_scale',
    label: 'Shot scale',
    family: '8. Visual composition and treatment',
    description: 'detail, close, medium, wide, establishing; per shot',
    evidence: 'F/V',
  },
  {
    key: 'visual.viewpoint',
    label: 'Viewpoint',
    family: '8. Visual composition and treatment',
    description: 'eye-level, low, high, overhead, first-person, through-door/window',
    evidence: 'F/V',
  },
  {
    key: 'visual.camera_motion',
    label: 'Camera motion',
    family: '8. Visual composition and treatment',
    description: 'locked, handheld, pan, tilt, push, pull, orbit, tracking, aerial-glide; per shot',
    evidence: 'V',
  },
  {
    key: 'visual.composition',
    label: 'Composition',
    family: '8. Visual composition and treatment',
    description:
      'symmetry, leading-lines, foreground-frame, layered-depth, negative-space, centered-subject',
    evidence: 'F/V',
  },
  {
    key: 'visual.lighting',
    label: 'Lighting',
    family: '8. Visual composition and treatment',
    description: 'daylight, golden-hour, blue-hour, night, warm-interior, mixed; multiple per post',
    evidence: 'F/V',
  },
  {
    key: 'visual.weather',
    label: 'Weather',
    family: '8. Visual composition and treatment',
    description: 'clear, cloudy, rain, fog, snow-visible; no season inference from snow alone',
    evidence: 'F/V',
  },
  {
    key: 'visual.palette',
    label: 'Palette',
    family: '8. Visual composition and treatment',
    description:
      'Dominant colors, warmth, saturation; observed appearance, not assumed grading process',
    evidence: 'F/V/D',
  },
  {
    key: 'visual.production_feel',
    label: 'Production feel',
    family: '8. Visual composition and treatment',
    description: 'casual-phone, polished, documentary, atmospheric, playful, mixed; interpretation',
    evidence: 'F/V',
  },
  {
    key: 'editing.duration_seconds',
    label: 'Duration seconds',
    family: '9. Editing and time',
    description: 'Actual duration with measurement precision',
    evidence: 'M/V',
  },
  {
    key: 'editing.shot_count',
    label: 'Shot count',
    family: '9. Editing and time',
    description: 'Number of shots under a documented boundary definition',
    evidence: 'V',
  },
  {
    key: 'editing.shot_durations',
    label: 'Shot durations',
    family: '9. Editing and time',
    description: 'Ordered durations, median, range; raw list bounded',
    evidence: 'V/D',
  },
  {
    key: 'editing.pace_curve',
    label: 'Pace curve',
    family: '9. Editing and time',
    description: 'Slow-to-fast, fast-to-slow, constant, alternating; derived from shots',
    evidence: 'V/D',
  },
  {
    key: 'editing.transitions',
    label: 'Transitions',
    family: '9. Editing and time',
    description: 'hard-cut, dissolve, match-cut, whip, occlusion, other; observed',
    evidence: 'V',
  },
  {
    key: 'editing.speed_treatment',
    label: 'Speed treatment',
    family: '9. Editing and time',
    description: 'real-time, slow-motion, timelapse, speed-ramp, still-animation, mixed',
    evidence: 'V/M',
  },
  {
    key: 'editing.sound_sync',
    label: 'Sound sync',
    family: '9. Editing and time',
    description: 'Beat-synced cuts, spoken-word sync, action-sound sync, none-observed, unknown',
    evidence: 'V + A',
  },
  {
    key: 'editing.carousel_structure',
    label: 'Carousel structure',
    family: '9. Editing and time',
    description: 'Slide count + role/order per slide; one cover image is insufficient',
    evidence: 'Complete carousel',
  },
  {
    key: 'people.presence',
    label: 'Presence',
    family: '10. People and performance',
    description:
      'none-observed, partial-body, single-person, multiple-people; describe visible scenes',
    evidence: 'F/V',
  },
  {
    key: 'people.role_in_scene',
    label: 'Role in scene',
    family: '10. People and performance',
    description:
      'presenter, participant, scale-reference, observer, background; no identity inference',
    evidence: 'F/V',
  },
  {
    key: 'people.activity',
    label: 'Activity',
    family: '10. People and performance',
    description:
      'walking-in, pointing, opening, using-feature, relaxing, cooking, working, reacting, talking',
    evidence: 'F/V',
  },
  {
    key: 'people.address',
    label: 'Address',
    family: '10. People and performance',
    description: 'direct-to-camera, off-camera, POV, no-address-observed',
    evidence: 'V/A',
  },
  {
    key: 'people.performance_style',
    label: 'Performance style',
    family: '10. People and performance',
    description:
      'candid-looking, posed, demonstration, comedic, explanatory; appearance not authenticity claim',
    evidence: 'V/A',
  },
  {
    key: 'overlay.role',
    label: 'Role',
    family: '11. On-screen text and visual hierarchy',
    description: 'hook, location, feature-label, subtitle, price, proof, CTA, disclosure',
    evidence: 'F/V/C',
  },
  {
    key: 'overlay.position',
    label: 'Position',
    family: '11. On-screen text and visual hierarchy',
    description: 'Bounding box and safe-area relationship per shot',
    evidence: 'F/V/D',
  },
  {
    key: 'overlay.word_count',
    label: 'Word count',
    family: '11. On-screen text and visual hierarchy',
    description: 'Words per overlay and peak simultaneous count',
    evidence: 'F/V/C/D',
  },
  {
    key: 'overlay.timing',
    label: 'Timing',
    family: '11. On-screen text and visual hierarchy',
    description: 'Entry/exit relative to shots and speech',
    evidence: 'V',
  },
  {
    key: 'overlay.visual_treatment',
    label: 'Visual treatment',
    family: '11. On-screen text and visual hierarchy',
    description: 'plain-type, outlined-type, solid-label, highlight, caption-box',
    evidence: 'F/V',
  },
  {
    key: 'overlay.hierarchy',
    label: 'Hierarchy',
    family: '11. On-screen text and visual hierarchy',
    description: 'Main headline vs secondary label vs subtitles; order and relative size',
    evidence: 'F/V',
  },
  {
    key: 'overlay.readability',
    label: 'Readability',
    family: '11. On-screen text and visual hierarchy',
    description: 'Contrast, crowding, truncation, obstruction; method named',
    evidence: 'F/V/D',
  },
  {
    key: 'overlay.cover_role',
    label: 'Cover role',
    family: '11. On-screen text and visual hierarchy',
    description: 'Cover differs from video, repeats opening, dedicated title-card, unknown',
    evidence: 'M/F/V',
  },
  {
    key: 'copy.caption_structure',
    label: 'Caption structure',
    family: '12. Caption and spoken-copy structure',
    description:
      'hook-benefit-details-CTA, short-invitation, story, checklist, guide, review, disclosure-led',
    evidence: 'C',
  },
  {
    key: 'copy.caption_length',
    label: 'Caption length',
    family: '12. Caption and spoken-copy structure',
    description: 'Actual words/characters; do not infer from truncated caption',
    evidence: 'Complete C',
  },
  {
    key: 'copy.voice',
    label: 'Voice',
    family: '12. Caption and spoken-copy structure',
    description:
      'conversational, practical, enthusiastic, reflective, humorous, editorial; interpretation',
    evidence: 'C/A',
  },
  {
    key: 'copy.address',
    label: 'Address',
    family: '12. Caption and spoken-copy structure',
    description: 'first-person-account, second-person, third-person, collective-we',
    evidence: 'C/A',
  },
  {
    key: 'copy.detail_mix',
    label: 'Detail mix',
    family: '12. Caption and spoken-copy structure',
    description: 'Sensory, factual, logistical, emotional, persuasive; evidence-backed categories',
    evidence: 'C/A',
  },
  {
    key: 'copy.hashtag_strategy',
    label: 'Hashtag strategy',
    family: '12. Caption and spoken-copy structure',
    description: 'Count plus place/activity/niche/branded/generic categories; no performance claim',
    evidence: 'Complete C',
  },
  {
    key: 'copy.speech_density',
    label: 'Speech density',
    family: '12. Caption and spoken-copy structure',
    description: 'Spoken words per minute and pause structure',
    evidence: 'A/V/D',
  },
  {
    key: 'audio.layers',
    label: 'Layers',
    family: '13. Sound and narration',
    description: 'speech, music, ambience, effects, silence; multiple',
    evidence: 'A',
  },
  {
    key: 'audio.narration_mode',
    label: 'Narration mode',
    family: '13. Sound and narration',
    description: 'presenter, voiceover, dialogue, no-speech-observed',
    evidence: 'A/V',
  },
  {
    key: 'audio.music_character',
    label: 'Music character',
    family: '13. Sound and narration',
    description: 'Descriptive genre/instrumentation/texture; broad abstraction',
    evidence: 'A',
  },
  {
    key: 'audio.tempo',
    label: 'Tempo',
    family: '13. Sound and narration',
    description: 'Measured BPM or coarse slow/mid/fast with method',
    evidence: 'A/D',
  },
  {
    key: 'audio.energy_curve',
    label: 'Energy curve',
    family: '13. Sound and narration',
    description: 'Low/mid/high and changes through the clip',
    evidence: 'A',
  },
  {
    key: 'audio.ambient_focus',
    label: 'Ambient focus',
    family: '13. Sound and narration',
    description: 'water, rain, fire, birds, footsteps, cooking, room-tone, other',
    evidence: 'A',
  },
  {
    key: 'audio.trend_status',
    label: 'Trend status',
    family: '13. Sound and narration',
    description: 'Platform-supported trend with dated evidence, not-confirmed, unknown',
    evidence: 'M',
  },
  {
    key: 'audio.speech_music_balance',
    label: 'Speech music balance',
    family: '13. Sound and narration',
    description: 'Speech-forward, music-forward, balanced, no-mix; measured if available',
    evidence: 'A',
  },
  {
    key: 'action.primary',
    label: 'Primary',
    family: '14. Action, promotion, and distribution context',
    description:
      'save, share, tag-companion, comment, request-link, follow, visit-profile, check-dates, book, none-observed',
    evidence: 'C/A/V',
  },
  {
    key: 'action.placement',
    label: 'Placement',
    family: '14. Action, promotion, and distribution context',
    description: 'caption, spoken, overlay, pinned-comment, end-card; multiple',
    evidence: 'C/A/V/M',
  },
  {
    key: 'action.destination',
    label: 'Destination',
    family: '14. Action, promotion, and distribution context',
    description: 'direct-booking, OTA, creator-profile, DM, guide, competition, unknown',
    evidence: 'M/C',
  },
  {
    key: 'action.incentive',
    label: 'Incentive',
    family: '14. Action, promotion, and distribution context',
    description: 'giveaway, discount, free-guide, exclusive-access, none-disclosed, unknown',
    evidence: 'C/M/N',
  },
  {
    key: 'action.engagement_prompt',
    label: 'Engagement prompt',
    family: '14. Action, promotion, and distribution context',
    description:
      'keyword-for-link, tag-to-enter, share-to-enter, opinion-question, organic-response, unknown',
    evidence: 'C/N',
  },
  {
    key: 'action.urgency_basis',
    label: 'Urgency basis',
    family: '14. Action, promotion, and distribution context',
    description: 'real-dates, stated-deadline, seasonal, vague-scarcity, no-urgency, unknown',
    evidence: 'M/C',
  },
  {
    key: 'action.distribution_evidence',
    label: 'Distribution evidence',
    family: '14. Action, promotion, and distribution context',
    description: 'paid-placement-confirmed, creator-partnership-only, organic-confirmed, unknown',
    evidence: 'M',
  },
  {
    key: 'metrics.published_at',
    label: 'Published at',
    family: '15. Performance and comparability',
    description: 'Platform publication timestamp + precision/unknown',
    evidence: 'M',
  },
  {
    key: 'metrics.observed_at',
    label: 'Observed at',
    family: '15. Performance and comparability',
    description: 'When each metric was observed; separate from import time',
    evidence: 'M',
  },
  {
    key: 'metrics.likes',
    label: 'Likes',
    family: '15. Performance and comparability',
    description: 'Nullable value, exact/rounded, platform scope, source evidence',
    evidence: 'M',
  },
  {
    key: 'metrics.views',
    label: 'Views',
    family: '15. Performance and comparability',
    description: 'Nullable value, view-definition/platform scope, exact/rounded',
    evidence: 'M',
  },
  {
    key: 'metrics.comments',
    label: 'Comments',
    family: '15. Performance and comparability',
    description: 'Nullable value; includes cross-platform comments flag',
    evidence: 'M',
  },
  {
    key: 'metrics.shares_reposts',
    label: 'Shares reposts',
    family: '15. Performance and comparability',
    description: 'Separate counters, nullable; do not combine synonymous UI labels blindly',
    evidence: 'M',
  },
  {
    key: 'metrics.saves',
    label: 'Saves',
    family: '15. Performance and comparability',
    description: 'Nullable; unavailable is not zero',
    evidence: 'M',
  },
  {
    key: 'metrics.reactions',
    label: 'Reactions',
    family: '15. Performance and comparability',
    description: 'Facebook total reactions separately from likes',
    evidence: 'M',
  },
  {
    key: 'metrics.creator_baseline',
    label: 'Creator baseline',
    family: '15. Performance and comparability',
    description: 'Same creator/platform/format/window eligible-post baseline + sample size',
    evidence: 'Repeated M + D',
  },
  {
    key: 'metrics.time_series',
    label: 'Time series',
    family: '15. Performance and comparability',
    description: 'Timestamped snapshots of the same metric; differences with comparable scope',
    evidence: 'Repeated M + D',
  },
  {
    key: 'adaptation.transferable_principle',
    label: 'Transferable principle',
    family: "16. Transfer to the host's own post",
    description: 'Original short description of the useful creative mechanism',
    evidence: 'Validated analysis',
  },
  {
    key: 'adaptation.target_subject',
    label: 'Target subject',
    family: "16. Transfer to the host's own post",
    description: 'Target fact/asset IDs that can fulfill the mechanism',
    evidence: 'P',
  },
  {
    key: 'adaptation.required_assets',
    label: 'Required assets',
    family: "16. Transfer to the host's own post",
    description: 'Shot roles and matching owned media IDs; gaps explicit',
    evidence: 'P + storyboard',
  },
  {
    key: 'adaptation.production_requirements',
    label: 'Production requirements',
    family: "16. Transfer to the host's own post",
    description:
      'Existing stills, recorded footage, new filming, presenter, motion, narration, editing',
    evidence: 'P + capabilities',
  },
  {
    key: 'adaptation.preserve',
    label: 'Preserve',
    family: "16. Transfer to the host's own post",
    description:
      'User-selected aspects: hook, beat order, framing, pace, sound direction, overlay, CTA',
    evidence: 'User choice + evidence',
  },
  {
    key: 'adaptation.replace',
    label: 'Replace',
    family: "16. Transfer to the host's own post",
    description:
      'Source property, names, people, specific claims, footage, wording, music recording',
    evidence: 'Source/target separation',
  },
  {
    key: 'adaptation.feasibility',
    label: 'Feasibility',
    family: "16. Transfer to the host's own post",
    description: 'ready, needs-assets, needs-facts, unsupported-capability, incompatible; reasons',
    evidence: 'P + capabilities',
  },
  {
    key: 'adaptation.acceptance_checks',
    label: 'Acceptance checks',
    family: "16. Transfer to the host's own post",
    description: 'Observable requested outcome + property fidelity + dimension-specific checks',
    evidence: 'User intent + plan',
  },
] as const;
export type InspirationDimension = (typeof INSPIRATION_DIMENSIONS)[number]['key'];
export function inspirationDimensionLabel(key: string): string {
  return INSPIRATION_DIMENSIONS.find((d) => d.key === key)?.label ?? key;
}
